<template>
  <div class="list-box fadeIn">
    <div class="list-content">
      <div class="list-box-title">
        <div class="list-title">{{ classInfo?.ClassName }}</div>
      </div>
      <div class="list">
        <div class="list-item" :class="{ lastSubmit: int.isLastSubmit }" :style="{ backgroundColor: theme_color }" v-for="(int, index) of intList" @click="chooseItem(int)" @mouseenter="switchBackground(int.Cover)" @mouseleave="switchBackground('')">
          <div class="list-num">{{ index + 1 }}</div>
          <div class="item-content">
            <p class="item-intname">{{ int.InductionName }}</p>
            <p class="item-des" v-if="int.Description">{{ int.Description }}</p>
          </div>
          <div class="code-list">
            <a-tooltip v-for="code of int.allcode" @click.stop="openUrl(int, code)" v-if="!int.isFinished">
              <template #title>{{ code.typeName }}：{{ code.Title }}</template>
              <div class="code-item">
                <svg class="icon-svg code-icon" v-if="!code.isSubmited">
                  <use :xlink:href="code.icon" />
                </svg>
                <svg class="icon-svg code-icon" v-if="code.isSubmited">
                  <use xlink:href="#icon-duihao" />
                </svg>
              </div>
            </a-tooltip>
            <div class="int-finished" v-if="int.isFinished">
              <svg class="icon-svg code-icon">
                <use xlink:href="#icon-duihao" />
              </svg>
              <span>已完成训练</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="list-rank" :class="{ 'myScore': userScore?.rank > 5 }" :style="{ backgroundColor: theme_color }">
      <div class="describe">
        <div class="describe-item">
          <div class="describe-top">
            <span>总分</span>
          </div>
          <p class="value">{{ userScore?.Score }}</p>
        </div>
        <div class="describe-item">
          <div class="describe-top">
            <span>完成度</span>
          </div>
          <div class="value">
            <p>{{ userScore?.submitPercent }}</p>
            <p class="percent">%</p>
          </div>
        </div>
        <div class="describe-item">
          <div class="describe-top">
            <span>排名</span>
          </div>
          <p class="value">{{ userScore?.rank }}</p>
        </div>
      </div>
      <div class="ranking-list-box">
        <div class="ranking-name-box">
          <p>排行榜</p>
        </div>
        <div class="ranking-title">
          <p class="title-name">排名</p>
          <p class="title-name" id="title-name">姓名</p>
          <p class="title-name">完成度</p>
          <p class="title-name">得分</p>
          <p class="title-name">徽章数</p>
        </div>
        <div class="ranking-box">
          <div class="ranking-list" v-for="item in stuList" :class="{ 'my-background': userScore?.rank == item.rank, 'hide': item.rank > 5 }">
            <p class="ranking-item">{{ item.rank }}</p>
            <p class="ranking-item" id="title-name">{{ item.NickName }}</p>
            <p class="ranking-item">{{ item.submitPercent }}%</p>
            <p class="ranking-item">{{ item.Score }}</p>
            <p class="ranking-item">{{ item.achievement?.length || 0 }}</p>
          </div>
          <div class="ranking-list my-background" v-if="userScore && userScore?.rank > 5">
            <p class="ranking-item">{{ userScore.rank }}</p>
            <p class="ranking-item" id="title-name">{{ userScore.NickName }}</p>
            <p class="ranking-item">{{ userScore.submitPercent }}%</p>
            <p class="ranking-item">{{ userScore.Score }}</p>
            <p class="ranking-item">{{ userScore.achievement?.length || 0 }}</p>
          </div>
        </div>
      </div>
    </div> -->
    <!-- iframe弹窗 -->
    <div class="new-popupbox" v-if="iframeUrl">
      <div class="hanlder-box">
        <svg class="icon-svg popup-close" @click="iframeUrl = ''">
          <use xlink:href="#icon-guanbi" />
        </svg>
      </div>
      <LoadingOutlined class="iframe-loading" />
      <iframe id="iframe-box" ref="iframeBox" class="box-content iframe-content"  allowfullscreen="true" :src="iframeUrl" scrolling="no" frameborder="0" :style="{backgroundColor:iframe_backcolor}" name="ifd" @load="listenIframeBox()"></iframe>
    </div>
  </div>
</template>

<script>

import { LoadingOutlined } from '@ant-design/icons-vue';

export default {
  components: {
    LoadingOutlined
  },
  name: "normal_list",
  props: {
    classInfo: Object,
    userScore: Object,
    intList: Array,
    stuList: Array,
  },
  data() {
    return {
      iframe_backcolor: '#ffffff00',
      theme_color: '',
      iframeUrl: ''
    }
  },
  async mounted() {
    let { platform, userInfo } = this.$store.state;
    this.theme_color = platform.pageConfig.theme_color;
    this.userInfo = userInfo;

    //自动定位的最近提交
    // setTimeout(() => {
    //   if ($('.lastSubmit').offset()) {
    //     let top = $('.lastSubmit').offset().top;
    //     $('.scroll-box').animate({ scrollTop: top - 50 }, 300);
    //   }
    // }, 100);
  },
  methods: {
    //选择单元
    chooseItem(int) {
      if (!int.preFinished && int.preIntName) return this.$message.warning(`请先完成前置单元《${int.preIntName}》，再开始此单元`);
      this.$emit('chooseItem', int)
    },
    //打开互动
    openUrl(int, code) {
      if (!int.preFinished && int.preIntName) return this.$message.warning(`请先完成前置单元《${int.preIntName}》，再开始此单元`);

      let token = this.userInfo.token;
      if (code.ProjectCode == 'kb') this.iframe_backcolor = '#ffffff';

      if (code.ProjectCode == "rpa") {
        let url = code.address.replace("${token}", token)
        window.open(url);
      }
      else this.iframeUrl = code.phoneIframe;
    },
    //切换背景
    switchBackground(cover) {
      this.$emit('switchBackground', cover)
    },
    //监听iframe弹窗
    listenIframeBox() {
      let that = this;
      this.$nextTick(() => {
        let iframe = that.$refs["iframeBox"];
        //发送值
        iframe.contentWindow.postMessage({
          command: 'postStudentId',
          data: {
            studentId: this.userInfo.PK_UserGuid,
          },
        }, '*')
      })
    },
  },
  //beforeUnmount() {},
}
</script>

<style scoped lang="scss">
@import "./normal-list.scss";
</style>